<template>
  <div>
    <div class="dashboard-filters d-flex clearfix">
      <div
        class="filter filter-select"
        :class="{ 'is-open': focusedFilter === 'campaigns' }"
      >
        <multi-select
          :options="campaignsFilter.options"
          :select-options="campaignsFilter.items"
          @opened="openedMultiselect('campaigns')"
          @closed="closedMultiselect()"
          v-model="campaigns"
          size="lg"
          btn-class="rounded-0"
        />
      </div>
      <div
        class="filter filter--calendar"
        :class="{ 'is-open': focusedFilter === 'dateRangeFilter' }"
      >
        <div class="position-relative">
          <svg-icon
            icon="chevron-down"
            class="text-light icon-xs events-none"
            :class="{ 'text-primary': focusedFilter === 'dateRangeFilter' }"
          />
          <input
            type="text"
            placeholder="Date Range"
            :value="formattedDateRange"
            @focus="showCalendar('dateRangeFilter')"
            @blur="closeCalendar('dateRangeFilter')"
          />
        </div>
        <transition name="fade">
          <v-date-picker
            class="right"
            mode="range"
            @mousedown.native="onMouseDown($event)"
            :theme-styles="dateRange.theme"
            :input-props="{
              class: '',
              placeholder: $t('endAfter'),
              autocomplete: 'off'
            }"
            :formats="dateRange.formats"
            is-inline
            v-show="dateRangeFilter"
            v-model="form['filter[dr]']"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      focusedFilter: '',
      dateRangeFilter: false,
      dateRange: {
        formats: {
          input: 'DD.MM.YYYY'
        },
        theme: this.$config.datepicker.base
      },
      campaigns: [
        {
          id: 'all',
          name: 'All sites'
        }
      ],
      campaignsFilter: {
        options: {
          multi: false
        },
        items: [
          {
            id: 'all',
            name: 'All sites'
          },
          {
            id: 'foo',
            name: 'Foo'
          },
          {
            id: 'bar',
            name: 'Bar'
          }
        ]
      },
      form: {
        'filter[c]': [],
        'filter[dr]': {
          start: new Date(2018, 10, 1),
          end: new Date(2018, 10, 8)
        }
      }
    };
  },

  computed: {
    formattedDateRange() {
      return `${this.$date.format(
        this.form['filter[dr]'].start,
        'DD.MM.YYYY'
      )} - ${this.$date.format(this.form['filter[dr]'].end, 'DD.MM.YYYY')}`;
    }
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.closeCalendar('dateRangeFilter');
      }
    }
  },

  methods: {
    openedMultiselect(val) {
      this.focusedFilter = val;

      // hack()
      setTimeout(() => {
        this.focusedFilter = val;
      }, 100);
    },
    closedMultiselect() {
      this.focusedFilter = '';
    },
    toggleMobileFilters() {
      this.show = !this.show;
    },
    showCalendar(name) {
      this[name] = true;
      this.openedMultiselect(name);
    },
    closeCalendar(name) {
      this.closedMultiselect();
      setTimeout(() => {
        this[name] = false;
      }, 100);
    },
    onMouseDown(e) {
      e.preventDefault();
    }
  }
};
</script>

<style lang="scss">
.dashboard-filters {
  width: 100%;

  .filter {
    flex-grow: 1;
    margin: -1px;
    width: 250px;
  }

  .is-open {
    position: relative;
    z-index: 2;
  }

  .filter-select {
    margin-right: 0;
  }

  .filter--calendar {
    position: relative;

    .c-pane-container {
      position: absolute;
      top: 100%;
      margin-top: 10px;

      &.left {
        left: 0;
      }

      &.right {
        right: 0;
      }
    }

    &.is-open {
      & > .position-relative input {
        box-shadow: inset 0 0 0 1px $secondary;
        border-color: $secondary;
      }
    }

    .position-relative {
      height: 100%;

      .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
      }

      & > input {
        margin: 0;
        background: none;
        border: none;
        height: 100%;
        padding: 12px;
        padding-right: 30px;
        border: 1px solid $border-color;
        border-right: 1px solid transparent;
        width: 100%;
        min-width: 130px !important;
        @extend %base-transition;

        &::placeholder {
          color: $body-color;
        }

        &:-ms-input-placeholder {
          color: $body-color;
        }

        &::-ms-input-placeholder {
          color: $body-color;
        }
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .dashboard-filters {
    display: none;
  }
}
</style>
